@if (isEpcotEnabled()) {
    <div class="popular-bets-pod__header">
        @if (pod().eventStartDate) {
            <ms-event-timer
                class="popular-bets-pod__header__date"
                [start]="pod().eventStartDate!"
                [isDynamicTimer]="false"
                [style.color]="pod().titleColor" />
        }
        @if (pod().title) {
            <div class="popular-bets-pod__header__title" [style.color]="pod().titleColor">{{ pod().title }}</div>
        }
    </div>
} @else {
    @if (pod().counter || podHeaderTitle()) {
        <div class="sports-and-counter-details" [class.popular-bets-pod-header-height]="!pod().isAllPodAreSameType">
            @if (podHeaderTitle()) {
                <div class="sports-details">
                    @if (pod().sport) {
                        <vn-icon size="12" [name]="'sports-' + pod().sport!.id" />
                    }
                    <span class="pod-title-name">{{ podHeaderTitle() }}</span>
                </div>
            }
            @if (pod().counter) {
                <div class="bet-counter-details">
                    <span class="bet-counter">{{ pod().counter }}</span>
                    <span class="bet-counter-text">{{ sitecorePopularBetsConfig.messages?.BetCounter }}</span>
                </div>
            }
        </div>
    }
}
